module.exports = __webpack_public_path__ + "static/img/17c.b752a2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/17c.jpg
// module id = i6xc
// module chunks = 0